import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";

const StoreFilterModal = ({
  storeFilterModalVisible,
  setStoreFilterModalVisible,
  sendDataToOrdersPageFromFilter,
  upDateSelectedStore,
  brandStoreData,
  status,
  text,
}) => {
  const [selectedStore, setSelectedStore] = useState([]);

  useEffect(() => {
    // Update localSelectedStore when selectedStore changes
    setSelectedStore(upDateSelectedStore);
  }, [upDateSelectedStore]);

  const handleStatusToggle = (Store) => {
    const updatedStore = [...selectedStore];

    if (updatedStore.includes(Store)) {
      // Remove Store if already selected
      updatedStore.splice(updatedStore.indexOf(Store), 1);
    } else {
      // Add Store if not selected
      updatedStore.push(Store);
    }

    setSelectedStore(updatedStore);
  };
  const handleConfirmPickup = () => {
    // Close the modal
    setStoreFilterModalVisible(false);
    sendDataToOrdersPageFromFilter(
      selectedStore.length > 0 ? selectedStore : "ALL"
    );
  };

  const handleModalClose = () => {
    setStoreFilterModalVisible(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={storeFilterModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!storeFilterModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <img
                style={{
                  height: 45,
                  width: 45,
                  // alignSelf: 'center',
                }}
                src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
              />

              <p className=" text-4xl text-primary-50 font-semibold">
                Select Store
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>

            <div
              className="h-20rem scroll-bar mb-2"
              style={{
                overflowY: "scroll",
              }}
            >
            <div className="mx-4">
              {brandStoreData?.map((item) => (
                <div key={item.id} className="flex flex-1 justify-content-between my-1">
                  <p className="text-xl font-medium">{item.storeName.replace(/_/g, " ")}</p>
                  <div>
                    <Checkbox
                      checked={selectedStore.includes(item.id)}
                      size="20" // Increased size
                      color={
                        selectedStore.includes(item.id)
                          ? "#00A3FF"
                          : "#C1C9D3"
                      }
                      onClick={() => handleStatusToggle(item.id)}
                    />
                  </div>
                </div>
              ))}
            </div>
            </div>

            <Button
              onClick={handleConfirmPickup}
              className="mt-1 mb-3 mx-4 border-round-xl "
            >
              <p className=" w-full text-2xl font-semibold flex justify-content-center">
                Filter
              </p>
            </Button>
          </div>
        )}
      ></Dialog>
    </div>
  );
};

export default StoreFilterModal;
